<template>
  <div class="AddProductToWebsiteTab">
    <WebsitesColumn class="websites-column"
      :loading="loading"
      
    
      @loaded-websites="v => websites = v"
      @website-click="toggleWebsite"
      ref="column"
    >
      <template #title>
        <span></span>
      </template>

      <template #website-radio="{domainname, uid}">
        <FormCheckbox
          class="checkbox"
          
          :ske="false"
          :gray-color="true"
          :value="websiteInclusionCheckboxes[uid]"
        >
          {{ domainname }}
        </FormCheckbox>
      </template>

      <template v-if="productId" #after="{uid}">
        <span>
          <router-link
            class="btn overwrite-link"
            :to="`/admin/overwrite-product/${productId}?website=${uid}&redirect-back-to-product-page=true`"

            @click.native.stop.prevent
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="pencil" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
            </svg>
  
            Overwrite product
          </router-link>
        </span>
      </template>
    </WebsitesColumn>
  </div>
</template>

<script>

import WebsitesColumn from "../../pages/website-products/Table/WebsitesColumn/WebsitesColumn.vue"
import FormCheckbox from "../Inputs/FormCheckbox.vue"

export default {
  components: {
    WebsitesColumn,
    FormCheckbox,
  },
  props: {
    value: Array,
    productId: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      websites: [],
      loading: true,
      websiteInclusionCheckboxes: {},
    }
  },
  methods: {
    async toggleWebsite(uid) {
      await this.$handlePromise(
        (async () => {
          let message = ""
              

          if (this.websiteInclusionCheckboxes[uid]) {
            if (this.productId) {
              await this.axios.delete(`/api/websites/${uid}/products/${this.productId}`)
              message = "Product van de website verwijderd!"
            } else {
              const websites = this.value.slice()
              websites.splice(
                websites.findIndex(webUid => webUid === uid),
                1
              )
              this.$emit("input", websites)
            }
          } else {
            if (this.productId) {
              await this.axios.put(`/api/websites/${uid}/products/${this.productId}`)
              message = "Product succesvol toegevoegd aan website!"
            } else {
              this.$emit("input", [...this.value, uid])
            }
          }
          this.$emit("toggle-website")
    
          if (this.productId) {
            this.$success(message)
            if (this.$refs.column) {
              this.$refs.column.resetAndRefetch()
            }
          }
        })()
      )
      this.loading = false
    },
    async toggleCorrectCheckboxes() {
      this.loading = true

      const productId = this.productId
      const checkboxes = {}
      await Promise.all(
        this.websites.map(async web => {
          const {results} = (await this.axios(`/api/websites/${web.uid}/products`, {
            params: {
              page_size: "10000"
            },
          })).data

          if (productId) {
            if (results.some(product => product.sku === productId)) {
              checkboxes[web.uid] = true
            }
          } else {
            if (this.value.includes(web.uid)) {
              checkboxes[web.uid] = true
            }
          }
        })
      )
      this.websiteInclusionCheckboxes = {}
      this.websiteInclusionCheckboxes = checkboxes
      
      this.loading = false
    },
  },
  watch: {
    websites() {
      this.toggleCorrectCheckboxes()
    },
    value() {
      this.toggleCorrectCheckboxes()
    },
  },
}

</script>

<style scoped>

.websites-column {
  width: 100% !important;
  border: none;
}

.checkbox {
  display: block;
}

.btn {
  border: 1px solid #E3E3E3;
  background-color: white;
  transition-duration: .15s;
}

.btn:hover {
  border: 1px solid transparent;
  background-color: #0081c7;
  color: white;
}

</style>

<style>

.AddProductToWebsiteTab .checkbox .form-check-label {
  margin-left: -10px !important;
}

</style>
